<template>
  <div>
    <!--    68 : 68-->
    <v-carousel
      v-if="imageBanners.length > 0"
      :height="$vuetify.display.smAndDown?'40px':'68px'"
      hide-delimiters
      cycle
      :show-arrows="false"
      class="header-banner-slider"
    >
       <v-carousel-item v-for="(banner, index) in imageBanners" :key="'class-id-' + index">
         <ImageBanners v-if="imageBanners.length" :bannerData="banner"></ImageBanners>
       </v-carousel-item>
    </v-carousel>
  </div>
</template>

<script>

import RepositoryFactory from '@/repositories/RepositoryFactory'
import ImageBanners from '@/components/header-banner/imageBanners.vue'

export default {
  name: 'bannerMain',
  components: {
    ImageBanners
  },
  data() {
    return {
      courseLiveData: {},
      imageBanners: {},
      LiveBannersRepo: RepositoryFactory.get('CourseVideos'),
      imageBannersRepo: RepositoryFactory.get('PromotionBanners')
    }
  },
  methods: {
    async getImageBanners() {
      try {
          const { data } = await this.imageBannersRepo.getTopBanners()
          this.imageBanners = data
      } catch (error) {
        console.log(error.response.data)
      }
    }
  },
  created() {
    this.getImageBanners()
  }
}
</script>

<style lang="scss">
.header-banner-slider {
  .slider-next:before,
  .slider-prev:before {
    color: white;
    opacity: 1;
    font-size: 42px !important;
  }
}
</style>
